import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AdminSiteState } from './types';
import { RootState } from '../types';

export const state: AdminSiteState = {
  adminSite: undefined,
  dataAdminSite: [],
};

const namespaced: boolean = true;

export const adminsite: Module<AdminSiteState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
